/**
 * WordPress dependencies
 */
import $ from 'jquery';

/** Internal Dependencies */
import SingleThumbnailGalleryController from './SingleThumbnailGallery';

export default class ThumbnailGalleryController {
	constructor() {
		this.elements = {
			galleryBlocks: $( '.wp-block-ncst-thumbnail-gallery' ),
		};
	}

	init() {
		for ( var i = 0; i < this.elements.galleryBlocks.length; i++ ) {
			let galleryController = new SingleThumbnailGalleryController(
				$( this.elements.galleryBlocks[ i ] ).attr( 'id' )
			);
			galleryController.init();
		}
	}
}
